import React from 'react';

import {Col, Preloader, Row} from "react-materialize";

export default class Loader extends React.Component {
    render() {
        return (
            <Row className="center-align">
                <Col s={12}>
                    <Preloader size='big'/>
                </Col>
            </Row>

        );
    }
}


// WEBPACK FOOTER //
// ./src/components/common/Loader.js